<template>
  <div>
    <div class="title" v-if="svipSource==='1'">
      <span class="mt9">今日限额已满</span>
    </div>
    <div class="title" v-if="svipSource==='4'">
      <p class="mt9">限额已满 借款失败</p>
    </div>
    <div class="img-te-quan"/>
    <div class="more">
      <div class="more-top">
        <div class="more-left">更多特权</div>
        <div class="more-right" @click="jumpVip">查看更多></div>
      </div>
      <div class="flex">
        <div v-for="(item,index) in more" :key="index" class="item" @click="jumpVip">
          <img :src="item.icon"/>
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    svipSource: String,
    lockAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
    }
  },
  computed: {
    more () {
      return [
        { icon: require('../images/icon_01@2x.png'), title: '利率67折' },
        { icon: require('../images/icon_02@2x.png'), title: `提额${this.lockAmount}元` },
        { icon: require('../images/icon_03@2x.png'), title: '首拒可退' },
        { icon: require('../images/icon_04@2x.png'), title: '惠享生活' }
      ]
    }
  },
  methods: {
    jumpVip () {
      this.$emit('jumpVip')
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../../../assets/less/mixin.less";

.flex{
    display: flex;
  }
.img-te-quan{
    width:670px;
    height:375px;
    margin:35px auto 0;
    background:url('../images/bg_a@2x.png');
    background-size:cover;
}
.title{
    text-align: center;
    height: 50px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 50px;
  }
.more{
    width: 670px;
    height: 268px;
    background: #FFFFFF;
    box-shadow: 0px 20px 30px 0px rgba(231, 231, 231, 0.5);
    border-radius: 20px;
    margin:20px auto 0;
    padding:37px 0 40px;
    .more-top{
      display:flex;
      justify-content: space-between;
      align-items: center;
      padding:0 30px;
    }
    &-left{
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    &-right{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .item{
      width:92px;
      width:197px;
      margin:36px 0;
      display:flex;
      flex-direction:column;
      align-items:center;
      >img{
        width:70px;
        height:70px;
      }
      >span{
        margin-top:15px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
</style>